export default class StudiesOverview {
    private filtersForm: HTMLFormElement

    constructor() {
        this.filtersForm = document.querySelector<HTMLFormElement>('.nimeto-filtered-studies-list')

        if (this.filtersForm) this.init()
        
    }

    private init() {
        const filtersDropdowns = this.filtersForm.querySelectorAll<HTMLElement>('.studies__filters')
        
        filtersDropdowns.forEach(dropdown => {
            const summary = dropdown.querySelector<HTMLElement>('.studies__filters-summary')

            summary?.addEventListener('click', () => {
                const dropdownIsOpen = dropdown.classList.contains('studies__filters--open')

                ;[...filtersDropdowns]
                    .filter(dropdown => dropdown.classList.contains('studies__filters--open'))
                    .forEach(dropdown => {
                        this.toggleDropdown(dropdown)
                    })
                
                if (!dropdownIsOpen) {
                    this.toggleDropdown(dropdown)
                }
            })
        })

        document.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape') return

            filtersDropdowns.forEach(dropdown => {
                if (dropdown.classList.contains('studies__filters--open')) {
                    this.toggleDropdown(dropdown)
                }
            })
        })

        // The same filter option is rendered in both the desktop and mobile
        // sets; keep their checked state in sync (the array signal is shared).
        this.filtersForm.addEventListener('change', (event) => {
            const target = event.target
            if (target instanceof HTMLInputElement && target.type === 'checkbox') {
                this.syncCheckbox(target)
            }
        })
    }

    syncCheckbox(target: HTMLInputElement) {
        const filter = target.getAttribute('data-filter')

        if (!filter || !target.value) return

        this.filtersForm
            .querySelectorAll<HTMLInputElement>(`input[data-filter="${filter}"][value="${CSS.escape(target.value)}"]`)
            .forEach(checkbox => {
                if (checkbox !== target) {
                    checkbox.checked = target.checked
                }
            })
    }

    toggleDropdown(dropdown: HTMLElement) {
        const summary = dropdown.querySelector<HTMLElement>('.studies__filters-summary')
        const details = dropdown.querySelector<HTMLElement>('.studies__filters-details')
        
        dropdown?.classList.toggle('studies__filters--open')
        details?.classList.toggle('hidden')
        details?.classList.toggle('flex')

        summary?.setAttribute('aria-expanded', summary?.getAttribute('aria-expanded') === 'false' ? 'true': 'false')
    }
}
